










import { AppointmentOutcome } from '@/shared/appointments/appointment-outcome';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppointmentOutcomeNotes extends Vue {
    @Prop({ required: true }) private appointmentOutcome!: AppointmentOutcome;
}
